export const PRA_REQUEST = "PRA_REQUEST";
export const PRA_SUCCESS = "PRA_SUCCESS";
export const PRA_FAIL = "PRA_FAIL";
